<template lang="pug">
  div.map-container.geo.map-objects
    div.toolbar
      div.line
        h1.title {{$translate('Карта')}}

    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
      :legendItems="legendItems"
    )

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title {{$translate('Слои')}}
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else)

            map-mapping-selector(
              :mappingConfObject="mappingConfObject"
              :selectedMappingObject="selectedMappingObject"
              @change="setSelectedMappingObject"
              @showEquidistant="onShowEquidistant"
              @setEquidistant="updateEquidistantCircle"
            )

            div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{$translate(item.label)}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{$translate(groupItem.label)}}
    router-view
</template>

<script>
  import {map as mapEndpoints} from "../../../api/api-endpoints";
  import MapMappingLegend from "../components/map-mapping-legend";
  import MapMappingSelector from "../components/map-mapping-selector"
  import objectsMixin from '../mixins/objects-mixin'
  import mappingMixin from '../mixins/mapping-mixin'

  import {DEFAULT_OPACITY, FORMED_POPUP, POP_POPUP, RECYCLE_POPUP, TOMB_POPUP, VILLAGE_ZOOM_ARR} from "../config/config";

  const REG_OPERATORS_POPUP = {
    head: 'Зона действия',
    fields: [
      {value: 'apoName', label: 'Наименование'},
      {value: 'name_with_type', label: 'Район'},
      {value: 'operatorName', label: 'Региональный оператор'},
      {value: 'total_garbage', label: 'Количество образованных отходов, тонн'},
      {value: 'total_garbage_cubic', label: 'Количество образованных отходов, м³'},
      {value: 'apoTotalGarbageSum', label: 'Количество образованных отходов по всей зоне, тонн'},
      {value: 'apoTotalGarbageCubicSum', label: 'Количество образованных отходов по всей зоне, м³'},
      {value: 'tariffLimitForecastValue', label: 'Прогнозное значение предельного тарифа на текущий регулируемый период, руб'},
      {value: 'tariff_processing', label: 'Тариф на обработку ТКО'},
      {value: 'tariff_neutralization', label: 'Тариф на обезвреживание ТКО'},
      {value: 'tariff_burial', label: 'Тариф на захоронение ТКО'},
      {value: 'tariff_collection', label: 'Собственные затраты регионального оператора'},
      {value: 'tariff_transportation', label: 'Цена на транспортирование ТКО'},
      {value: 'tariff_regop_common', label: 'Единый тариф на услугу Регионального оператора'},
    ]
  }

  export default {
    mixins: [objectsMixin, mappingMixin],
    components: {MapMappingSelector, MapMappingLegend},
    mounted() {
      this.map.on('zoomend', () => {
        if (this.selectedMappingObject == 'formed') {
          this.onMappingCurrentLegend();
        }
      });
      this.map.on('zoomend', () => {
        if (this.selectedMappingObject == 'population') {
          this.onMappingCurrentLegend();
        }
      });
      this.map.on('zoomend', () => {
        if (this.selectedMappingObject == 'recycle') {
          this.onMappingCurrentLegend();
        }
      });
      this.map.on('zoomend', () => {
        if (this.selectedMappingObject == 'tomb') {
          this.onMappingCurrentLegend();
        }
      });
    },
    computed: {
      mappingConfObject () {
        return {
          population: {
            title: 'Население',
            legends: [
              {
                endpoint: mapEndpoints.heatMapPopulationDistrict,
                valueKey: 'population',
                popup: POP_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-25 тыс.', min: 0, style: {color: '#fad089'}},
                  {title: '25-50 тыс.', min: 25000, style: {color: '#ff9c5b'}},
                  {title: '50-75 тыс.', min: 50000, style: {color: '#f5634a'}},
                  {title: '75-100 тыс.', min: 75000, style: {color: '#ed313c'}},
                  {title: 'от 100 тыс.', min: 100000, style: {color: '#a8016d'}}
                ]
              },
              {
                hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                valueKey: 'population',
                endpoint: mapEndpoints.heatMapPopulationSettlement,
                popup: POP_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-25 тыс.', min: 0, style: {fillColor: '#fad089', color: '#ff9c5b'}},
                  {title: '25-50 тыс.', min: 25000, style: {fillColor: '#ff9c5b', color: '#ff9c5b'}},
                  {title: '50-75 тыс.', min: 50000, style: {fillColor: '#f5634a', color: '#ff9c5b'}},
                  {title: '75-100 тыс.', min: 75000, style: {fillColor: '#ed313c', color: '#ff9c5b'}},
                  {title: 'от 100 тыс.', min: 100000, style: {fillColor: '#a8016d', color: '#ff9c5b'}}
                ]
              }
            ]
          },
          formed: {
            title: 'Количество образованных отходов',
            legends: [
              {
                endpoint: mapEndpoints.heatMapFormedDistrict,
                valueKey: 'formed',
                popup: FORMED_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-25 тыс.', min: 0, style: {color: '#74db54'}},
                  {title: '25-50 тыс.', min: 25000, style: {color: '#bbe668'}},
                  {title: '50-100 тыс.', min: 50000, style: {color: '#f6e548'}},
                  {title: '100-250 тыс.', min: 100000, style: {color: '#ffc90e'}},
                  {title: 'от 250 тыс.', min: 250000, style: {color: '#ed313c'}}
                ]
              },
              {
                hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                endpoint: mapEndpoints.heatMapFormedSettlement,
                valueKey: 'formed',
                popup: FORMED_POPUP,
                items: [
                  {title: '1-25 тыс.', min: 0, style: {color: '#74db54'}},
                  {title: '25-50 тыс.', min: 25000, style: {color: '#bbe668'}},
                  {title: '50-100 тыс.', min: 50000, style: {color: '#f6e548'}},
                  {title: '100-250 тыс.', min: 100000, style: {color: '#ffc90e'}},
                  {title: 'от 250 тыс.', min: 250000, style: {color: '#ed313c'}}
                ]
              }
            ]
          },
          recycle: {
            title: 'Количество переработанных отходов',
            legends: [
              {
                endpoint: mapEndpoints.heatMapRecycleDistrict,
                valueKey: 'recycle',
                popup: RECYCLE_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-100 тыс.', min: 0, style: {color: '#cfe2f1'}},
                  {title: '100-300 тыс.', min: 100000, style: {color: '#88bfdc'}},
                  {title: '0,3-1 млн.', min: 300000, style: {color: '#2c98df'}},
                  {title: '1-5 млн.', min: 1000000, style: {color: '#0056a9'}},
                  {title: 'от 5 млн.', min: 5000000, style: {color: '#1b3c6e'}}
                ]
              },
              {
                hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                endpoint: null,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-50 тыс.', min: 0, style: {color: '#cfe2f1'}},
                  {title: '50-150 тыс.', min: 50000, style: {color: '#88bfdc'}},
                  {title: '150-500 тыс.', min: 150000, style: {color: '#2c98df'}},
                  {title: '0,5-2 млн.', min: 500000, style: {color: '#0056a9'}},
                  {title: 'от 2 млн.', min: 2000000, style: {color: '#1b3c6e'}}
                ]
              }
            ]
          },
          tomb: {
            title: 'Количество захороненных отходов',
            legends: [
              {
                endpoint: mapEndpoints.heatMapTombDistrict,
                valueKey: 'tomb',
                popup: TOMB_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-100 тыс.', min: 0, style: {color: '#cff09e'}},
                  {title: '100-300 тыс.', min: 100000, style: {color: '#a8dba8'}},
                  {title: '0,3-1 млн.', min: 300000, style: {color: '#79bd9a'}},
                  {title: '1-5 млн.', min: 1000000, style: {color: '#3b8686'}},
                  {title: 'от 5 млн.', min: 5000000, style: {color: '#0b486b'}}
                ]
              },
              {
                hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                endpoint: null,
                items: [
                  {title: '1-50 тыс.', min: 0, style: {color: '#cff09e'}},
                  {title: '50-150 тыс.', min: 50000, style: {color: '#a8dba8'}},
                  {title: '150-500 тыс.', min: 150000, style: {color: '#79bd9a'}},
                  {title: '0,5-2 млн.', min: 500000, style: {color: '#3b8686'}},
                  {title: 'от 2 млн.', min: 2000000, style: {color: '#0b486b'}}
                ]
              }
            ]
          },
          regOperatorsZones: {
            title: 'Зоны деятельности региональных операторов',
            legends: [
              {
                popup: REG_OPERATORS_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                valueKey: false,
                hideLegend: true,
                endpoint: mapEndpoints.heatMapRegOperatorsDistrict,
                items: [
                  {min: 0}
                ]
              },
              {
                popup: REG_OPERATORS_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                valueKey: false,
                hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                endpoint: mapEndpoints.heatMapRegOperatorsSettlement,
                items: [
                  {min: 0}
                ]
              }
            ]
          }
        }
      }
    },
    methods: {
      getLayersConf () {
        return {
          gs: {
            menuClass: 'oth',
            label: 'Отходообразователи',
            endpoint: mapEndpoints.source,
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              org: {
                menuClass: 'oth-hoz',
                iconType: 'org',
                label: 'Организация/ИП',
                restApiOrder: 2
              },
              def: {
                menuClass: 'oth-minOb',
                iconType: 'def',
                label: 'Объекты министерства обороны',
                restApiOrder: 4
              },
              med: {
                menuClass: 'oth-med',
                iconType: 'med',
                label: 'Медицинские учреждения',
                restApiOrder: 5
              },
              ind: {
                menuClass: 'oth-individ',
                iconType: 'ind',
                label: 'Индивидуальное домовладение',
                restApiOrder: 6
              },
              gsk: {
                menuClass: 'oth-garage',
                iconType: 'gsk',
                label: 'ГСК',
                restApiOrder: 8
              },
              apartmentBuildings: {
                menuClass: 'oth-apartment-buildings',
                iconType: 'apartmentBuildings',
                label: 'Многоквартирные дома',
                restApiOrder: 9
              }
            }
          },
          msn: {
            iconType: 'places',
            menuClass: 'places',
            label: 'Места сбора и накопления',
            endpoint: mapEndpoints.msn,
            className: 'cluster-marker msn',
            groups: {
              container: {
                menuClass: 'places-cont',
                iconType: 'container',
                label: 'Контейнерные площадки',
                restApiOrder: 1
              },
              noContainer: {
                menuClass: 'places-noCont',
                iconType: 'noContainer',
                label: 'Бесконтейнерный сбор',
                restApiOrder: 2
              },
              separate: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Пункты сбора вторсырья',
                restApiOrder: 3
              }
            }
          },
          dump: {
            iconType: 'svalka',
            menuClass: 'svalka',
            label: 'Несанкционированные свалки',
            endpoint: mapEndpoints.heap,
            className: 'cluster-marker heap',
            groups: {
              heap: {
                menuClass: 'svalka-thrash',
                iconType: 'thrash',
                label: 'Навалы мусора',
                restApiOrder: 1
              },
              unauth: {
                endpoint: mapEndpoints.object,
                menuClass: 'svalka-noThrash',
                iconType: 'noThrash',
                label: 'Несанкционированные ОРО',
                restApiOrder: 2
              }
            }
          },
          object: {
            iconType: 'garbage',
            menuClass: 'obj',
            label: 'Объекты обращения с отходами',
            endpoint: mapEndpoints.object,
            className: 'cluster-marker object',
            groups: {
              process: {
                menuClass: 'obj-obrab',
                iconType: 'process',
                label: 'Объекты обработки',
                restApiOrder: 2
              },
              util: {
                menuClass: 'obj-utiliz',
                iconType: 'util',
                label: 'Объекты утилизации',
                restApiOrder: 5
              },
              neutral: {
                menuClass: 'obj-obezvr',
                iconType: 'neutral',
                label: 'Объекты обезвреживания',
                restApiOrder: 3
              },
              storage: {
                menuClass: 'obj-chran',
                iconType: 'storage',
                label: 'Объекты хранения',
                restApiOrder: 4
              },
              burial: {
                menuClass: 'obj-zachoron',
                iconType: 'burial',
                label: 'Объекты захоронения',
                restApiOrder: 6
              },
              consumption: {
                menuClass: 'obj-consumption',
                iconType: 'consumption',
                label: 'Объекты потребления продуктов переработки',
                restApiOrder: 11
              },
              accommodation: {
                menuClass: 'obj-accommodation',
                iconType: 'accommodation',
                label: 'Размещение ',
                restApiOrder: 12
              },
              transportation: {
                menuClass: 'obj-tran',
                iconType: 'tran',
                label: 'Объекты транспортировки',
                restApiOrder: 1
              }
            }
          },
          transport: {
            menuClass: 'transp',
            label: 'Транспортировщики',
            endpoint: mapEndpoints.transport,
            className: 'cluster-marker transport',
            iconType: 'transp',
            groups: {
              trans: {
                hideFromMenu: true,
                iconType: 'transport',
                label: 'Транспортировщики',
                restApiOrder: 1
              }
            }
          },
          products: {
            menuClass: 'product',
            label: 'Потребители продуктов переработки',
            endpoint: mapEndpoints.product,
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              product: {
                endpoint: mapEndpoints.source,
                hideFromMenu: true,
                menuClass: 'oth-hoz',
                iconType: 'product',
                label: 'Потребители продуктов переработки',
                restApiOrder: 'item',
                routeName: (fields = {}) => {
                  let type = fields.garbage_source_type_id
                  if (type && GARBAGE_TYPE_ROUTE_NAME_MAP[type]) {
                    return GARBAGE_TYPE_ROUTE_NAME_MAP[type]
                  }
                  return null
                }
              }
            }
          }
        }
      }
    }
  }
</script>
